
import respUtility from '@/mixins/respUtility';

export default {
  name: 'BrandBannerContent',
  mixins: [respUtility],
  props: {
    brandRating: {
      type: Object,
      default() { return {}; },
    },
    title: {
      type: String,
    },
    brandTitle: {
      type: String,
    },
    brandSlug: {
      type: String,
      default: '',
    },
    brandUrl: {
      type: String,
      default: '',
    },
    description: {
      type: String,
      default: '',
    },
    isBrandBoutiqueTitle: {
      type: Boolean,
      default: false,
    },
    isBrandPage: {
      type: Boolean,
    },
    isCollectionPage: {
      type: Boolean,
    },
    logo: {
      type: Object,
      default() { return {}; },
    },
    isMobile: {
      type: Boolean,
    },
    isBoutiquePage: {
      type: Boolean,
    },
  },
};
